import React from 'react'
import { CheckSquareOutlined, DownOutlined, FileOutlined, LaptopOutlined, PieChartOutlined, ToolOutlined, UsergroupAddOutlined, WalletOutlined } from '@ant-design/icons';
import { Dropdown, Space } from 'antd';
import { useLocation, useNavigate, Link } from "react-router-dom";
import { TbReport } from "react-icons/tb";
import useProfileData from '../../hooks/useProfileData';

export default function IsrNavbar() {
    const { profileData } = useProfileData();
    const userRole = profileData.userRole;
    const userData = JSON.parse(localStorage.getItem("userData"));
    const probationInfo = JSON.parse(localStorage.getItem("probationInfo"));
    const reviewFormLink = (profileData.appraisalFormId) ?
        (profileData.appraisalFormId === 1) ? `Appraisal/1?EmpId=${profileData.loginId}` :
            (profileData.appraisalFormId === 2) ? `Appraisal/2?EmpId=${profileData.loginId}` :
                (profileData.appraisalFormId === 3) ? `Appraisal/3?EmpId=${profileData.loginId}` :
                    (profileData.appraisalFormId === 5) ? `Appraisal/5?EmpId=${profileData.loginId}` :
                        'Appraisal/Not-Found' :
        'Appraisal/Not-Found'
    const onClick = ({ key }) => {
        // message.info(`Click on item ${key}`);
        navigate(`/${key}`, { replace: true });
    };
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const items = [
        {
            label: 'Customer Master',
            key: profileData.userRole === "ISR" ? 'CustList' : profileData.userRole === "Head ISR" && 'CustomerMaster',
        },
        {
            label: 'Add Customer',
            key: 'modifyCust',
        },
    ];

    const attendance = [
        {
            label: 'Mark Attendance',
            key: 'Attendance/MarkAttendance'
        },
        {
            label: 'Attendance Report',
            key: 'Attendance/AttendanceList'
        },
        {
            label: 'Request Leave',
            key: 'Attendance/RequestLeave'
        },
        {
            label: 'Leave History',
            key: 'Attendance/LeaveHistory'
        },
        {
            label: "Subordinates Leave History",
            key: "LeaveDetail/SubordinateLeaveHistory"
        }
        // {
        //     label: 'Attendance Report',
        //     key: 'Attendance/AttendanceReport'
        // },
        // {
        //     label: 'Absent Report',
        //     key: 'Attendance/AbsentReport'
        // }
    ]

    const DARActivityMailMaster = [
        {
            label: "DAR Mail Master",
            key: "DARActivityMailMaster",
        },
    ];
    const order = [
        {
            label: 'Order Processing',
            key: 'OrderDefault'
        },
        {
            label: 'Order Details',
            key: 'Order/Details/List'
        }
    ];

    const training = [
        {
            label: 'Schedule Training',
            key: 'Training/Schedule'
        },
        {
            label: 'Training Feedback',
            key: 'Training/Feedback'
        },
        {
            label: "Suggesstions",
            key: 'Training/Suggestions'
        },
        {
            label: 'Training Details',
            key: 'Training/Details'
        }
    ];

    const reviewAndPerformace = [
        {
            label: "My Review Form",
            key: reviewFormLink
        },
        {
            label: "Manager Audit",
            key: "Appraisal/ManagerAuditEmpList",
        },

    ];


    const Kras = [
        {
            label: "My KRA",
            key: "MyKRAForm",
        },
        {
            label: "Approve KRA",
            key: "ManagerKRAapproval",
        },
    ];
    const DarData = [
        {
            label: "DAR Summary",
            key: "DarSummary",
        },
        {
            label: "DAR Entry",
            key: "AddDar",
        },
    ];

    const reimbursement = [
        {
            label: "Reimbursement",
            key: "Reimbursement",
        },
        {
            label: "List",
            key: 'Reimbursement/List'
        }
    ];

    const info = [
        {
            label: "Subordinate Resignation List",
            key: "ResignationInfo/ReportingHeadList",
            isVisible: userData.isReportingHead
        },
        {
            label: "Resignation Status",
            key: "ResignationInfo/ResignationStatus",
            isVisible: userData.isResigned
        }
    ].filter(item => item.isVisible);

    return (
        <div className='dropdown-navbar'>
            {/* <div></div> */}
            <Dropdown
                menu={{
                    items,
                    onClick,
                }}
            >
                <a onClick={(e) => e.preventDefault()} style={{ color: 'black', fontSize: '13px', fontWeight: 600 }}>
                    <Space>
                        <UsergroupAddOutlined />Customer Master<DownOutlined />
                    </Space>
                </a>
            </Dropdown>
            <Dropdown
                menu={{
                    items: DarData,
                    onClick,
                }}
            >
                <a onClick={(e) => e.preventDefault()} style={{ color: 'black', fontSize: '13px', fontWeight: 600 }}>
                    <Space>
                        <ToolOutlined />Dar<DownOutlined />
                    </Space>
                </a>
            </Dropdown>
            <Dropdown
                className="mx-2"
                menu={{
                    items: Kras,
                    onClick,
                }}
            >
                <a
                    onClick={(e) => e.preventDefault()}
                    style={{ color: "black", fontSize: "13px", fontWeight: 600 }}
                >
                    <Space>
                        <PieChartOutlined />
                        KRA
                        <DownOutlined />
                    </Space>
                </a>
            </Dropdown>

            <Dropdown
                className='mx-3'
                menu={{
                    items: [
                        {
                            label: 'Create Quotation',
                            key: 'CreateQuotation'
                        },
                        {
                            label: 'Quotation List',
                            key: 'QuotationList'
                        }
                    ],
                    onClick,
                }}
            >
                <a onClick={(e) => e.preventDefault()} style={{ color: 'black', fontSize: '13px', fontWeight: 600 }}>
                    <Space>
                        <FileOutlined />Quotation<DownOutlined />
                    </Space>
                </a>
            </Dropdown>

            {/* <Link
          to="/ITEquipment"
          style={{
            color: "black",
            fontSize: "13px",
            fontWeight: 600,
            marginLeft: "0.75rem",
          }}
        >
          <Space>
            <LaptopOutlined />
            IT Equipment Inventory
          </Space>
        </Link> */}

            <Dropdown
                menu={{
                    items: order,
                    onClick,
                }}
            >
                <a onClick={(e) => e.preventDefault()} style={{ color: 'black', fontSize: '13px', fontWeight: 600 }}>
                    <Space>
                        <ToolOutlined />Order<DownOutlined />
                    </Space>
                </a>
            </Dropdown>

            {/* <Dropdown
                menu={{
                    items: training,
                    onClick,
                }}
            >
                <a onClick={(e) => e.preventDefault()} style={{ color: 'black', fontSize: '13px', fontWeight: 600 }}>
                    <Space>
                        <ToolOutlined />Training<DownOutlined />
                    </Space>
                </a>
            </Dropdown> */}

            {
                pathname.includes("/Attendance") &&
                <Dropdown
                    menu={{
                        items: attendance,
                        onClick
                    }}
                >
                    <a onClick={(e) => e.preventDefault()} style={{ color: 'black', fontSize: '13px', fontWeight: 600, marginLeft: '0.75rem' }}>
                        <Space>
                            <ToolOutlined />Attendance Details<DownOutlined />
                        </Space>
                    </a>
                </Dropdown>
            }

            <Dropdown
                menu={{
                    items: reviewAndPerformace,
                    onClick,
                }}
            >
                <a
                    onClick={(e) => e.preventDefault()}
                    style={{
                        color: "black",
                        fontSize: "13px",
                        fontWeight: 600,
                        marginLeft: "0.75rem",
                    }}
                >
                    <Space>
                        <ToolOutlined />
                        Review
                        <DownOutlined />
                    </Space>
                </a>
            </Dropdown>

            {
                (userRole === "Head ISR" || userData.userRole === "Head ISR" || [1274].includes(userData.loginId)) && (
                    <Link to="/DAR/ActivityStatus" style={{
                        fontSize: '14px',
                        color: 'black',
                        fontWeight: 500
                    }}>
                        <Space>
                            <ToolOutlined /> DAR Activity Status
                        </Space>
                    </Link>

                )
            }
            {
                userRole === "Head ISR" && (
                    <Dropdown
                        className="mx-1"
                        menu={{
                            items: DARActivityMailMaster,
                            onClick,
                        }}
                    >
                        <a
                            style={{ color: "black", fontSize: "13px", fontWeight: 600 }}
                            onClick={(e) => e.preventDefault()}
                        >
                            <Space>
                                <ToolOutlined />
                                <span style={{ fontSize: "14px" }}>Mail Master</span>
                                <DownOutlined />
                            </Space>
                        </a>
                    </Dropdown>

                )
            }

            {/* isr dar list --> commented for now */}
            {/* <Dropdown
                menu={{
                    items: DarList,
                    onClick
                }}
            >
                <a onClick={(e) => e.preventDefault()} style={{ color: 'black', fontSize: '13px', fontWeight: 600, marginLeft: '0.75rem' }}>
                    <Space>
                        <UsergroupAddOutlined />DAR<DownOutlined />
                    </Space>
                </a>
            </Dropdown> */}
            {/* <Link
                to="/WeeklyReport"
                style={{
                    color: "black",
                    fontSize: "13px",
                    fontWeight: 600,
                    marginLeft: "0.75rem",
                }}
            >
                <Space>
                    <TbReport />
                    Weekly Report
                </Space>
            </Link> */}
            {/* <Dropdown
                menu={{
                    items: reimbursement,
                    onClick,
                }}
            >
                <a onClick={(e) => e.preventDefault()} style={{ color: 'black', fontSize: '13px', fontWeight: 600 }}>
                    <Space>
                        <ToolOutlined />Reimbursement<DownOutlined />
                    </Space>
                </a>
            </Dropdown> */}

            {
                probationInfo && probationInfo?.isOnProbation && !(userData.isResigned) && (
                    <Link
                        to="/Confirmation/CheckProbation"
                        style={{
                            color: "black",
                            fontSize: "13px",
                            fontWeight: 600,
                            marginLeft: "0.75rem",
                        }}
                    >
                        <Space>
                            <CheckSquareOutlined />
                            Probation
                        </Space>
                    </Link>
                )
            }
            {
                userData.isReportingHead && (
                    <Link
                        to="/ResignationInfo/ReportingHeadList"
                        style={{
                            color: "black",
                            fontSize: "13px",
                            fontWeight: 600
                        }}
                    >
                        <Space>
                            <CheckSquareOutlined />
                            Resignation List
                        </Space>
                    </Link>
                )
            }

            {
                info.length > 0 && (
                    <Dropdown
                        menu={{
                            items: info,
                            onClick,
                        }}
                    >
                        <a
                            onClick={(e) => e.preventDefault()}
                            style={{
                                color: "black",
                                fontSize: "13px",
                                fontWeight: 600,
                                marginLeft: "0.75rem",
                            }}
                        >
                            <Space>
                                <ToolOutlined />
                                Info
                                <DownOutlined />
                            </Space>
                        </a>
                    </Dropdown>
                )
            }

            <Link
                to="/Order/Pipeline/List"
                style={{
                    color: "black",
                    fontSize: "13px",
                    fontWeight: 600,
                    marginLeft: "0.75rem",
                }}
            >
                <Space>
                    <WalletOutlined />
                    Order Pipeline
                </Space>
            </Link>
        </div>

    )
}
